import { Routes, Route } from 'react-router';
import { AppShell } from '@mantine/core';
import { PortalFormPage } from '@ferp-sites/template';
import HomePage from '../overrides/pages/HomePage';

function App() {
  return (
    <AppShell padding={0}>
      <AppShell.Main id="main-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/forms/:portalSlug/:workflowSlug" element={<PortalFormPage />} />
        </Routes>
      </AppShell.Main>
    </AppShell>
  );
}

export default App;
